import React from 'react';
import styles from './SimpleButton.module.css';

interface SimpleButtonProps {
    text: string;
    onClick: () => void;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({ text, onClick }) => {
    return (
        <button className={styles.button} onClick={onClick}>
            {text}
        </button>
    );
};

export default SimpleButton;
